import { lockPage, unlockPage } from './helpers';
import breakpoints from '../../json/breakpoints.json';

export class Menu {
    constructor() {
        const mql = window.matchMedia(`(max-width: ${breakpoints.l}px)`)

        if(mql.matches) {
            this.addEventListeners()
        }

        mql.addListener(e => {
            if (e.matches) {
                if (this.header) {
                    this.addEventListeners()
                }
            }
        })
    }

    addEventListeners() {
        if(this.header) {
            this.menuTrigger.addEventListener('click', () => {
                if (!this.menu.classList.contains('menu-open')) {
                    this.open()
                    lockPage()
                } else {
                    this.close()
                    unlockPage()
                }
            })
            document.addEventListener('keydown', e => {
                if (e.key === 'Escape') {
                    this.close()
                }
            })
        }
    }

    get header() {
        return document.querySelector('#js-header') || false
    }

    get menu() {
        return document.querySelector('#js-menu') || false
    }

    get menuTrigger() {
        const menuTrigger = document.querySelector('#js-menu-trigger')
        return menuTrigger ? menuTrigger : false
    }

    open() {
        this.header.classList.add('menu-active')
        this.menuTrigger.classList.add('menu-open')
        setTimeout(() => {
             this.menu.classList.add('menu-open')
        }, 200)
    }

    close() {
        this.menu.classList.remove('menu-open')
        this.menuTrigger.classList.remove('menu-open')
        setTimeout(() => {
            this.header.classList.remove('menu-active')
       }, 200)
    }
}
